import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { MODULE_INITIALIZER } from '@spartacus/core';
import { timer } from 'rxjs';
import { effects } from './effects';
import { PaymentService } from './services';
import { PaymentLazyService } from './services/payment-lazy.service';

function initPaymentsFactory(paymentLazyService: PaymentLazyService): () => void {
  return () => {
    timer(0).subscribe(() => paymentLazyService.init());
  };
}

@NgModule({
  imports: [EffectsModule.forFeature(effects)],
  providers: [
    PaymentLazyService,
    {
      provide: PaymentService,
      useExisting: PaymentLazyService,
    },
    {
      provide: MODULE_INITIALIZER,
      useFactory: initPaymentsFactory,
      deps: [PaymentLazyService],
      multi: true,
    },
  ],
})
export class PaymentFeatureModule {}
